import React from "react";
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex flex-col gap-[10px] border-t-[1px] border-t-black">
            <div className="bg-[#0B2C3D] py-[10px] text-white text-center font-bold">{t("© 2025 Ligasos All rights reserved.")}</div>
        </footer>
    );
}